import React from "react";
import DropDown from "../DropDown/DropDown";
import "./BedCustomizations.scss";
import CheckBox from "../Checkbox/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import {
  setBedColor,
  setBedSize,
  setBedWithMattress,
  setBedMattressType,
  setBedFabric,
  setMSB,
  setBedDrawer,
  setBedBD,
} from "../../Redux/BedCustomizations/BedCustomizations.actions";
import { drawers, fabrics, mattressTypes, bds } from "../../Config/constant";
import colorchart from "../../Assets/colorchart.jpg";
import { toggleColorChart } from "../../Redux/Toggles/Toggles.actions";

const BedCustomizations = () => {
  const color = useSelector((state) => state.bedCustomizations.color);
  const size = useSelector((state) => state.bedCustomizations.size);
  const fabric = useSelector((state) => state.bedCustomizations.fabric);
  const drawer = useSelector((state) => state.bedCustomizations.drawer);
  const bd = useSelector((state) => state.bedCustomizations.bd);
  const matchingStorageBox = useSelector(
    (state) => state.bedCustomizations.matchingStorageBox
  );
  const data = useSelector((state) => state.products.activeProduct);
  const mattressType = useSelector(
    (state) => state.bedCustomizations.mattressType
  );
  const withMattress = useSelector(
    (state) => state.bedCustomizations.withMattress
  );
  const dispatch = useDispatch();

  const handleSizeChange = (value) => {
    const fullSize = data.others.sizes.filter(
      (size) => size.value === value
    )[0];
    dispatch(setBedSize(fullSize));
  };

  const handleMattresTypeChange = (mattressType) => {
    const MattressType = mattressTypes.filter(
      (MT) => MT.value === mattressType
    )[0];
    dispatch(setBedMattressType(MattressType));
  };

  return (
    <div className="BedCustomizations">
      <h2>Customizations</h2>
      <DropDown
        name="size"
        text="Size"
        data={data.others.sizes}
        value={size.value}
        onChange={(e) => handleSizeChange(e.target.value)}
      />
      <CheckBox
        name="withMattress"
        label={`With Mattress (+${size.mattressPrice - size.price})`}
        value={withMattress}
        onChange={(e) => dispatch(setBedWithMattress(e.target.checked))}
      />{" "}
      <br />
      {withMattress && (
        <DropDown
          name="mattressType"
          data={mattressTypes}
          value={mattressType.value}
          onChange={(e) => handleMattresTypeChange(e.target.value)}
        />
      )}
      <CheckBox
        name="matchingStorageBox"
        label={`Matching Storage Box (+80)`}
        value={matchingStorageBox}
        onChange={(e) => dispatch(setMSB(e.target.checked))}
      />
      <DropDown
        name="fabric"
        text="Fabric"
        data={fabrics}
        value={fabric.value}
        onChange={(e) =>
          dispatch(
            setBedFabric(
              fabrics.find((fabric) => fabric.value === e.target.value)
            )
          )
        }
      />
      <img
        onClick={() => dispatch(toggleColorChart(true))}
        src={colorchart}
        alt="color chart"
        className="colorImg"
      />
      <DropDown
        name="color"
        text="Color"
        data={fabric.colors}
        value={color}
        colors
        onChange={(color) => dispatch(setBedColor(color.target.value))}
      />
      {!data.others.isPanel && (
        <DropDown
          name="bd"
          text="Buttons or Diamonds"
          data={bds}
          value={bd}
          colors
          onChange={(e) => dispatch(setBedBD(e.target.value))}
        />
      )}
      {data.others.isDeewan ? (
        <DropDown
          name="drawers"
          text="Drawers"
          data={drawers}
          value={drawer.value}
          onChange={(e) =>
            dispatch(
              setBedDrawer(
                drawers.find((drawer) => drawer.value === e.target.value)
              )
            )
          }
        />
      ) : null}
    </div>
  );
};

export default BedCustomizations;
